import { auth } from "./guards";
export default Route => {
  // 订单
  Route.group({ prefix: "/order", beforeEnter: auth }, () => {
    Route.view("/", () =>
      import(/* webpackChunkName: "order" */ "../views/order/index.vue")
    ).name("order");
    Route.view("/detail/:policyCode", () =>
      import(/* webpackChunkName: "order" */ "../views/order/detail.vue")
    ).options({
      name: "order-detail",
      props: true
    });
    Route.view("/insureApply/:policyCode", () =>
      import(/* webpackChunkName: "order" */ "../views/order/insureApply.vue")
    ).options({
      name: "insureApply",
      props: true
    });
    Route.view("/add/:policyCode", () =>
      import(/* webpackChunkName: "order" */ "../views/order/add.vue")
    ).options({
      name: "order-add",
      props: true
    });
    Route.view("/reduce/:policyCode", () =>
      import(/* webpackChunkName: "order" */ "../views/order/reduce.vue")
    ).options({
      name: "order-reduce",
      props: true
    });
  });
};
